import { isString } from 'lodash-es';
import moment from 'moment-timezone';

import { FilterTypes } from '../types';

const operatorMap = {
  equals: ':',
  greaterThanOrEqual: ':>=',
  greaterThan: ':>',
  lessThanOrEqual: ':<=',
  lessThan: ':<',
};

function serializeDateValue(dateValue) {
  let str = '';

  if (dateValue.value instanceof Date) {
    str += dateValue.value.toISOString();
  } else {
    str += dateValue.value;
  }

  if (dateValue.round) {
    str += '/' + dateValue.round;
  }

  for (const modifier of dateValue.modifiers || []) {
    const isPositive = modifier.value >= 0;
    str += (isPositive ? '+' : '-') + Math.abs(modifier.value) + modifier.unit;
  }

  return str;
}

function serializeValue(value, isKeyword: boolean = false) {
  const admiralFormat = 'YYYY-MM-DDZ';

  if (value instanceof Date) {
    return moment(value).format(admiralFormat);
  } else if (value && value.value) {
    return serializeDateValue(value);
  } else if (isString(value) || isKeyword) {
    return '"' + value.replace(/"/g, '\\"') + '"';
  } else {
    return value;
  }
}

export function serialize(filters: FilterTypes[]) {
  return (
    filters
      // complexity 21
      // eslint-disable-next-line complexity
      .map((filter: FilterTypes) => {
        switch (filter.operator) {
          case 'past':
          case 'next':
          case 'between':
          case 'range':
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              ':' +
              serializeValue(filter.start) +
              '..' +
              serializeValue(filter.end)
            );
          case 'keyword':
            return (
              (filter?.negated ? '-' : '') + serializeValue(filter.value, true)
            );
          case 'in':
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              ':in(' +
              filter.value.map((v) => serializeValue(v)).join(', ') +
              ')'
            );
          case 'contains':
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              ':contains(' +
              serializeValue(filter.value) +
              ')'
            );
          case 'matchesRegex':
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              ':matchesRegex(' +
              serializeValue(filter.value) +
              ')'
            );
          case 'matchesWildcard':
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              ':matchesWildcard(' +
              serializeValue(filter.value) +
              ')'
            );
          case 'containKeyValue':
          case 'isInIpRange':
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              ':' +
              serializeValue(filter.value)
            );
          case 'null':
            return (filter?.negated ? '-' : '') + filter.prop + ':null';

          default:
            return (
              (filter?.negated ? '-' : '') +
              filter.prop +
              operatorMap[filter.operator] +
              serializeValue(filter.value)
            );
        }
      })
      .join(' ')
  );
}
